import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  se: {
    description: 'Höjdpunkter och mål från alla Viasats sport rättigheter så som Premier League, Champions League, Seria A, La liga, League 1, NHL, NFL, Golf och mycket mer. Såklart också alla Zlatans mål från Premier League.',
    title: 'Video',
  },
  no: {
    description: 'Høydepunkter og mål fra Champions League, La Liga, Serie A, NFL, NHL, UFC og mange andre ligaer.',
    title: 'Video',
  },
  dk: {
    description: 'Video, højdepunkter og mål fra Champions League, Premiere League, ALKA Superligaen, La Liga, Serie A, NFL, NHL, UFC, Golf og mange andre danske og internationale sportsgrene og ligaer.',
    title: 'Video',
  },
  fi: {
    description: 'Koosteet, kohokohdat, maalit, maailman parhaista liigoista. Valioliiga, UEFA Champions League, NHL, KHL, Serie A, La Liga, FA Cup, UFC, NFL, Golf ja paljon muuta.',
    title: 'Videot',
  },
};

export default class VideoMeta extends React.PureComponent {
  render() {
    return (
      <BasicMeta descriptions={descriptions} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Video/VideoMeta.jsx